import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ContactPerson {
  lastName: string;
  firstName: string;
  attachments: string[];
  referenceBy: string;
  mobileNumber: string;
  businessNumber: string;
}

export interface SubscriptionModule {
  name: string;
  label: string;
  endDate: string;
  startDate: string;
}

export interface DistributorData {
  id: number;
  name: string;
  email: string;
  phoneNumber: string;
  address1: string;
  address2: string;
  city: string;
  state: string;
  province: string;
  coDbaName: string;
  status: boolean;
  contactPerson: ContactPerson;
  subscriptionStartDate: string;
  subscriptionEndDate: string;
  subscriptionModules: SubscriptionModule[];
  createdAt: string;
  updatedAt: string;
}

interface DistributorState {
  selectedDistributor: any | null;
  loading: boolean;
  error: string | null;
}

const initialState: DistributorState = {
  selectedDistributor: null,
  loading: false,
  error: null,
};

const distributorSlice = createSlice({
  name: 'distributor',
  initialState,
  reducers: {
    setSelectedDistributorForView: (state, action: PayloadAction<any>) => {
        console.log("setSelectedDistributorForView called with:", action.payload);
      state.selectedDistributor = action.payload;
      state.error = null;
      console.log("State updated, selectedDistributor is now:", state.selectedDistributor);
    },
    clearSelectedDistributor: (state) => {
      state.selectedDistributor = null;
      state.error = null;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const {
    setSelectedDistributorForView,
  clearSelectedDistributor,
  setLoading,
  setError,
} = distributorSlice.actions;

export default distributorSlice.reducer; 